import ForgotPassword from "./components/login/ForgotPassword";
import Login from "./components/login/Login";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/dashboard/Dashboard";
import Home from "./pages/Home/Home";
import navRoutes from "./routes/route";
import { Provider } from "react-redux";
import { store } from "./store";
import Logout from "./components/login/Logout";
import ResetPassword from "./components/login/ResetPassword";
import { RecoilRoot } from "recoil";
import ScrollToTop from "./utils/UI/scrollToTop";
import TwoFactorAuth from "./components/TwoFactorAuth";
import Setup2FA from "./components/Setup2FA";

const App = () => {
  return (
    <RecoilRoot>
      <Router>
          <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />}>
            {navRoutes?.map((route, item) => {
              const Component = route.component;
              if (item === 0) {
                return <Route index key={route.path + item} path={route.path} element={<Component />} />;
              } else {
                return <Route key={route.path + item} path={route.path} element={<Component />} />;
              }
            })}
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/2fa" element={<TwoFactorAuth />} />
          <Route path="/setup2fa" element={<Setup2FA />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
      </Router>
    </RecoilRoot>
  );
};

export default App;
